module.exports = __webpack_public_path__ + "img/flares_of_fury.59d75800.jpg";